/**
 * Immediately invokes the function with the given args
 * @purpose - avoid using iife's
 */
export const run = <T extends (...args: any[]) => any>(
  fn: T,
  params: Parameters<T>,
): ReturnType<T> => {
  return fn(...params);
};

/**
 * JSON.parse that returns undefined instead of throwing
 */
export const tryParseJSON = (t: string): any | undefined => {
  try {
    return JSON.parse(t);
  } catch (err) {
    return undefined;
  }
};
